import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { STChange, STColumn, STReq, STData, STRes, STPage, STRequestOptions } from '@delon/abc';
import { _HttpClient, ModalHelper, ModalHelperOptions } from '@delon/theme';
// import { URLS } from 'projects/common-lib/src/lib/constant/interface';
// import { _MSGTYPES } from 'projects/common-lib/src/lib/constant/msgType';
import { DialogService } from 'icc-common-lib';
// import { URLS, _MSGTYPES } from '@shared';
// import { DialogService } from '@services/dialog.service';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';
import { URLS } from '../../shared/constant/interface';
import { _MSGTYPES } from '../../shared/constant/msgType';
// import { EventService } from '@services/event.service';

@Component({
  selector: 'icc-tiktok-fans',
  templateUrl: './tiktok-fans-manage.component.html',
  styleUrls: ['./tiktok-fans-manage.component.less'],
  host: {
    '[style.width]': "'100%'"
  }
})
export class TiktokFansManageComponent implements OnInit {
static NAME = 'icc-msg-fans';
  type = _MSGTYPES.MT.TIKTOK.type;
  constructor(private http: _HttpClient, private modal: ModalHelper, private dialogService: DialogService) {}
  url = URLS.tiktokFansList.url;

  // 列表
  @ViewChild('st', { static: false }) st: any;
  columns: STColumn[] = [
    // { title: '', index: 'id', type: 'checkbox' },
    {
      title: '粉丝昵称',
      index: 'nickname',
      className: 'text-center',
    },
    {
      title: 'OPENID',
      index: 'openId',
      render: 'tpl-openId',
      width: 300,
      className: 'text-center',
    },
    {
      title: '所在国家',
      index: 'country',
      default: '/',
      render: 'templ-country',
      className: 'text-center',
    },
    {
      title: '所在城市',
      index: 'city',
      default: '/',
      render: 'templ-city',
      className: 'text-center',
    },
  ];

  req: STReq = {
    method: 'POST',
    allInBody: true,
    body: {
      params: {
        nickname: '',
        state: -1,
        tagId: -1,
        officialAccountId: -1,
      },
    },
    process: (requestOptions: STRequestOptions) => {
      return requestOptions;
    },
  };
  res: STRes = {
    // reName: {list:"data"}
  };
  page: STPage = {};

  options: ModalHelperOptions = {
    /** 大小；例如：lg、600，默认：`lg` */
    size: 100,
  };

  // 获取更新按钮重复提交控制
  disabledClick = false;

  /*searchOptions*/
  searchOptions: any = {
    nickname: '',
    openId: '',
    channelId: -1,
  };
  expandForm = false;
  // count = 0;
  selectNode;

  tiktokAccounts = [];

  isLoading = false;

  actIndex = null;
  getTableList() {
    this.st.reset({
      params: {
        // key: value  =》 接口参数名: 对应值
        nickname: this.searchOptions.nickname,
        channelId: this.searchOptions.channelId,
        openId: this.searchOptions.openId,
      },
    });
  }

  /**
   * 获取粉丝
   * @param channelId
   */
  getFans(channelId, itemIdx) {
    this.actIndex = itemIdx;
    this.searchOptions.nickname = '';
    this.searchOptions.openId = '';
    this.searchOptions.channelId = channelId;
    this.getTableList();
  }

  resetTableList() {
    // 重置搜索条件
    this.searchOptions.nickname = '';
    this.searchOptions.openId = '';
    // 重新加载table数据
    this.getTableList();
  }
  ngOnInit() {
    this.getTiktokAccounts();
  }

  // 获取更新
  update() {
    const numbers = interval(1000);
    const takeFourNumbers = numbers.pipe(take(10));
    takeFourNumbers.subscribe(error => {});
    if (!this.disabledClick) {
      this.disabledClick = true;

      this.http.post(URLS.tiktokFansUpdate.url, { channelId: this.searchOptions.channelId }).subscribe(res => {
        if (res.status === 0) {
          this.disabledClick = false;
          this.resetTableList();
          this.dialogService.notification.success(`获取更新`, '更新完成！');
          // this.dialogService.notification.success(`获取更新`, '更新完成，请刷新！');
        } else {
          this.disabledClick = false;
          this.dialogService.notification.error(`获取更新`, `${res.errorMsg}`);
        }
      });
    }
  }

  // 获取抖音号
  getTiktokAccounts() {
    this.http.post(URLS.tiktokAccountList.url, {}).subscribe(res => {
      if (res.status === 0 && res.data.length > 0) {
        this.tiktokAccounts = res.data;
        this.searchOptions.channelId = res.data[0].id;
        this.resetTableList();
      }
    });
  }

  stChange(e: STChange) {
    switch (e.type) {
      case 'checkbox':
        break;
      // case 'filter':
      //   this.getUsersSilence();
      //   break;
    }
  }
}
